export default {
  container: {
    "& .answers-wrapper": {
      marginBottom: "20px",
      paddingTop: "50px",
      "&.answer-radio-type, &.answer-checkbox-type": {
        display: "flex",
        flexFlow: "row wrap"
      }
    }
  }
};
